module.exports = __webpack_public_path__ + "img/icon_teacher2.be153c2.png";